import OapProductVariantSelector from './code/Scripts/components/OapProductVariantSelector.vue';

export default {
  components: {
    OapProductVariantSelector,
  },
};
